import styled from 'styled-components';
import { MaxWidthWrapper } from 'styles/default';

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  min-height: 2rem;
  padding: 0 4vw;

  p {
    color: ${props => props.theme.color[props.messageColor]};
  }
`;

export const MainWrapper = styled(MaxWidthWrapper)`
  margin: 0 auto;
`;
